import React from 'react'
import PropTypes from 'prop-types'
import './weekly_discount.scss'
import { Trans } from 'react-i18next'

export class WeeklyDiscount extends React.Component {
  render() {
    const {discountPercentage} = this.props
    if (discountPercentage) {
      return (
        <div styleName="discount-container">
          <Trans i18nKey="search.listing_item.weekly_discount" >
            <span>７泊以上の連泊で<span styleName="discount-rate"><span className='notranslate'>{{discount: discountPercentage}}</span>%OFF</span></span>
          </Trans>
        </div>
      )
    } else {
      return null
    }
  }
}

WeeklyDiscount.propTypes = {
  discountPercentage: PropTypes.number
}

WeeklyDiscount.defaultProps = {
  discountPercentage: 0
}

export default WeeklyDiscount
